import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toEventItem } from '../adapters/event.adapter';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  eventsControllerFindBySlug,
  EventsControllerFindBySlug$Params,
  eventsControllerFindInPreparation,
  EventsControllerFindInPreparation$Params,
  eventsControllerFindPast,
  EventsControllerFindPast$Params,
  eventsControllerFindUpcoming,
  EventsControllerFindUpcoming$Params,
} from '@klubovna/api-client';
import { EventResponse, ApiPaginatedResponse } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { EventItem } from '@shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class EventsApiService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiConfig = inject(ApiConfiguration);

  getUpcomingEvents(page: number = 1, limit: number = 20, search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): Observable<PaginatedResponse<EventItem>> {
    const params: EventsControllerFindUpcoming$Params = {
      page,
      limit,
      search,
      tagIds,
      dateFrom,
      dateTo,
    };

    return eventsControllerFindUpcoming(this.http, this.apiConfig.rootUrl, params).pipe(
      map(response => toPaginatedResponse<EventResponse>(response.body as ApiPaginatedResponse)),
      map(paginated => ({
        ...paginated,
        items: paginated.items.map(toEventItem),
      })),
    );
  }

  getPastEvents(page: number = 1, limit: number = 20, search?: string, tagIds?: string[], dateFrom?: string, dateTo?: string): Observable<PaginatedResponse<EventItem>> {
    const params: EventsControllerFindPast$Params = {
      page,
      limit,
      search,
      tagIds,
      dateFrom,
      dateTo,
      private: false,
    };

    return eventsControllerFindPast(this.http, this.apiConfig.rootUrl, params).pipe(
      map(response => toPaginatedResponse<EventResponse>(response.body as ApiPaginatedResponse)),
      map(paginated => ({
        ...paginated,
        items: paginated.items.map(toEventItem),
      })),
    );
  }

  getEventBySlug(slug: string): Observable<EventItem> {
    const params: EventsControllerFindBySlug$Params = { slug };

    return eventsControllerFindBySlug(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toEventItem(response.body as EventResponse)));
  }

  getPreparationEvents(page: number = 1, limit: number = 20, search?: string, tagIds?: string[], _dateFrom?: string, _dateTo?: string): Observable<PaginatedResponse<EventItem>> {
    const params: EventsControllerFindInPreparation$Params = {
      page,
      limit,
      search,
      tagIds,
    };

    return eventsControllerFindInPreparation(this.http, this.apiConfig.rootUrl, params).pipe(
      map(response => toPaginatedResponse<EventResponse>(response.body as ApiPaginatedResponse)),
      map(paginated => ({
        ...paginated,
        items: paginated.items.map(toEventItem),
      })),
    );
  }
}
